import PageHero from "@/components/PageHero";
import { Scroll, ScrollText, Target, Megaphone, FileQuestion, BadgeCheck, Users } from "lucide-react";

const SECTIONS = [
  {
    id: "sankalp", icon: Users, title: "Team S.A.N.K.A.L.P",
    body: "Founded by Dr. Abhishek Garg in 2025, Team S.A.N.K.A.L.P — Sewa-oriented Alliance for Nation-building, Knowledge, Accountability, Leadership & Policy — is a doctor-led platform driving ethical reform, mentorship, and policy advocacy. Sankalp's motto: नीतिना राष्ट्रं भूषितम् — a nation adorned by ethics."
  },
  {
    id: "act", icon: ScrollText, title: "DMC Act — Overview",
    body: "The Delhi Medical Council Act regulates the practice of modern scientific medicine in Delhi. As an Executive Member, Dr. Garg pledges to uphold and modernise the Act — defending doctors against frivolous complaints and ensuring patient trust through transparent processes."
  },
  {
    id: "manifesto", icon: Megaphone, title: "DMC Manifesto",
    body: "A reform agenda anchored in four pillars — Ethical, Accessible, Committed, Transparent: faster grievance redressal, transparent registration & renewal, online complaint tracking, support for medico-legal defence, mentorship for young doctors, women-doctor safety, ethical CME oversight, and an open public dashboard."
  },
  {
    id: "vision", icon: Target, title: "DMC Vision",
    body: "A Council that is digital-first, doctor-friendly, ethically uncompromising, and publicly accountable — a model for medical councils across India. Strong Representation. Transparent Governance. Better Future for Doctors."
  },
  {
    id: "post", icon: BadgeCheck, title: "DMC Post — Executive Member",
    body: "Executive Members participate in the council's governance, policy formation, registration oversight, and disciplinary hearings. They serve as the primary voice for working doctors. DMC Elections — 31st May 2026 (Sunday), at DMC Office. Voters: All Registered Medical Practitioners of Delhi."
  },
  {
    id: "rti", icon: FileQuestion, title: "RTI on DMC Activities",
    body: "Dr. Garg has filed and supported multiple RTIs to surface delays in registration, complaint disposal, and council expenditure. The campaign commits to publishing council activity reports openly."
  },
  {
    id: "campaigns", icon: Scroll, title: "Campaigns & Activities",
    body: "Field meetings across Delhi, doctor town halls, RWA dialogues, and digital outreach. Recent visits include the Delhi Medical Council with Team Sankalp members. Every event is open and inclusive — every voice matters."
  },
];

export default function DMCElection() {
  return (
    <div data-testid="dmc-election-page">
      <PageHero
        eyebrow="DMC Election Hub"
        title="Everything about the Council, the contest, and our pledge."
        subtitle="One place for the Act, the manifesto, the vision, the post, the RTIs and the campaigns we run."
      />

      <section className="section-y">
        <div className="container-x">
          {/* Quick anchor index */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-16">
            {SECTIONS.map((s) => (
              <a key={s.id} href={`#${s.id}`} data-testid={`dmc-anchor-${s.id}`}
                className="border border-[hsl(var(--border-c))] p-4 hover:border-[hsl(var(--accent))] hover:bg-[hsl(var(--bg-muted))] transition-all">
                <s.icon size={18} className="text-[hsl(var(--accent))]" />
                <div className="text-sm font-medium mt-2 text-[hsl(var(--primary))]">{s.title}</div>
              </a>
            ))}
          </div>

          <div className="space-y-20">
            {SECTIONS.map((s, i) => (
              <div key={s.id} id={s.id} className="grid md:grid-cols-12 gap-8" data-testid={`dmc-section-${s.id}`}>
                <div className="md:col-span-3">
                  <div className="font-display text-6xl text-[hsl(var(--accent))]/30">0{i + 1}</div>
                  <s.icon className="text-[hsl(var(--accent))] mt-2" size={28} />
                </div>
                <div className="md:col-span-9">
                  <h2 className="font-display text-3xl sm:text-4xl text-[hsl(var(--primary))]">{s.title}</h2>
                  <p className="mt-4 text-[hsl(var(--fg-muted))] leading-relaxed text-lg">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
